import { post } from '../api.js';
import { encryptItem } from '../crypto.js';
import { navigate } from '../router.js';
import { setTopbar, lucideIcons, esc } from '../app.js';
import { enqueueFiles, onAllComplete, clearCompleteCallbacks } from '../upload-queue.js';


export function renderItemCreate(container) {
  setTopbar('New Item', '');

  container.innerHTML = `
    <div class="breadcrumb" id="back-to-items"><i data-lucide="arrow-left" style="width:16px;height:16px"></i> Back to Items</div>
    <div class="card" style="max-width:600px">
      <div id="create-msg"></div>

      <div class="form-group" style="margin-bottom:20px">
        <label style="font-weight:600;margin-bottom:8px;display:block">Upload Files</label>
        <div class="landing-drop" id="fileDrop" style="padding:32px 20px;max-width:none">
          <div class="drop-icon" style="width:48px;height:48px;margin-bottom:12px"><i data-lucide="upload-cloud" style="width:22px;height:22px"></i></div>
          <p class="drop-desktop-hint" style="font-size:14px">Drop files here or click to upload</p>
          <label for="fileInput" class="btn btn-primary drop-mobile-btn"><i data-lucide="file-up" style="width:18px;height:18px"></i> Choose Files</label>
          <span>Encrypted in your browser before upload</span>
          <input type="file" id="fileInput" multiple style="display:none">
        </div>
      </div>

      <div style="display:flex;align-items:center;gap:16px;margin-bottom:20px">
        <div style="flex:1;height:1px;background:var(--border)"></div>
        <span style="font-size:13px;color:var(--text-secondary);text-transform:uppercase;letter-spacing:.1em">or add a text secret</span>
        <div style="flex:1;height:1px;background:var(--border)"></div>
      </div>

      <form id="create-form">
        <div class="form-group"><label>Name</label><input class="form-input" type="text" name="name" required placeholder="e.g. AWS Root Credentials"></div>
        <div class="form-group"><label>Content</label><textarea class="form-input" name="content" placeholder="Paste your secret content here..." rows="5"></textarea></div>
        <div style="margin-top:24px"><button type="submit" class="btn btn-primary">Encrypt & Save</button></div>
      </form>
    </div>
  `;
  lucideIcons();

  document.getElementById('back-to-items').onclick = () => navigate('#/items');

  // File upload
  const fileDrop = document.getElementById('fileDrop');
  const fileInput = document.getElementById('fileInput');

  fileDrop.addEventListener('click', (e) => {
    if (e.target === fileInput || e.target.closest('.drop-mobile-btn')) return;
    fileInput.click();
  });
  fileDrop.addEventListener('dragover', (e) => { e.preventDefault(); fileDrop.classList.add('dragover'); });
  fileDrop.addEventListener('dragleave', () => fileDrop.classList.remove('dragover'));
  fileDrop.addEventListener('drop', (e) => {
    e.preventDefault();
    fileDrop.classList.remove('dragover');
    if (e.dataTransfer.files.length) {
      enqueueFiles(e.dataTransfer.files, {});
      navigate('#/items');
    }
  });
  fileInput.addEventListener('change', () => {
    if (fileInput.files.length) {
      enqueueFiles(fileInput.files, {});
      navigate('#/items');
    }
  });

  // Text secret form
  document.getElementById('create-form').onsubmit = async (e) => {
    e.preventDefault();
    const msg = document.getElementById('create-msg');
    const btn = e.target.querySelector('button[type=submit]');
    const name = e.target.name.value;
    const content = e.target.content.value;
    btn.disabled = true;
    msg.innerHTML = '';

    if (!content) {
      msg.innerHTML = '<div class="msg msg-error">Enter content</div>';
      btn.disabled = false;
      return;
    }

    const overlay = document.createElement('div');
    overlay.className = 'encrypt-overlay';
    overlay.innerHTML = `<div class="encrypt-box"><div class="spinner"></div><p>Encrypting...</p><div class="mono">XChaCha20-Poly1305 + X25519</div></div>`;
    document.body.appendChild(overlay);

    try {
      const envelope = JSON.stringify({ item_type: 'document', name, content });
      const enc = encryptItem(envelope);
      await post('/items', {
        encrypted_blob: enc.encrypted_blob,
        wrapped_key: enc.wrapped_key,
        nonce: enc.nonce,
        item_type: 'encrypted',
        metadata: {},
      });
      overlay.remove();
      navigate('#/items');
    } catch (err) {
      overlay.remove();
      msg.innerHTML = `<div class="msg msg-error">${esc(err.message)}</div>`;
      btn.disabled = false;
    }
  };
}
